export default "__VITE_ASSET__xzx5VVbz__"